import { BCMSDate, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import OneTimeACHPaymentPage, { getDefaultData, getDefaultUI } from "components/pages/OneTimeACHPaymentPage";
import Classes, { Account } from "model";

export default function CaptureOffsetAccountSelected(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const effectiveDate = BCMSDate.init().nextBusinessDay().nextBusinessDay();
    
    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "oneTimeACHPayment", "transactionType" ], "payment")
    .update([ "oneTimeACHPayment", "secCode" ], "CCD Credit - Non-Consumer Credit")
    .update([ "oneTimeACHPayment", "scheduleType" ], "future dated")
    .update([ "oneTimeACHPayment", "effectiveDate" ], effectiveDate)
    .update([ "oneTimeACHPayment", "companyEntryDescription" ], "ACH PMT")
    .update([ "oneTimeACHPayment", "company" ], "0")
    .update([ "selectedOffsetAccount", "account" ], Account.initByID("6"))
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "showOneTimeACHModal", "isActive" ], false)
    .update([ "showSecCode", "isActive" ], true)
    .submit();

    return <OneTimeACHPaymentPage data={ data } ui={ ui } />;
}